module.exports = __webpack_public_path__ + "img/elementheights_jas.66a28f22.png";